var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cf-node-properties__input" }, [
    _c(
      "select",
      {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.selectValue,
            expression: "selectValue"
          }
        ],
        staticClass: "form-control",
        class: { invalid: _vm.error },
        attrs: { required: _vm.required },
        on: {
          change: function($event) {
            var $$selectedVal = Array.prototype.filter
              .call($event.target.options, function(o) {
                return o.selected
              })
              .map(function(o) {
                var val = "_value" in o ? o._value : o.value
                return val
              })
            _vm.selectValue = $event.target.multiple
              ? $$selectedVal
              : $$selectedVal[0]
          }
        }
      },
      _vm._l(_vm.options, function(option, index) {
        return _c("option", { key: index, domProps: { value: option.value } }, [
          _vm._v("\n      " + _vm._s(option.name) + "\n    ")
        ])
      }),
      0
    ),
    _vm._v(" "),
    _vm.errorMessage
      ? _c("div", { staticClass: "cf-node-properties__input-error" }, [
          _vm._v("\n    " + _vm._s(_vm.errorMessage) + "\n  ")
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }